/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAccountQueryResponse } from './FindAccountQueryResponse';
import {
    FindAccountQueryResponseFromJSON,
    FindAccountQueryResponseFromJSONTyped,
    FindAccountQueryResponseToJSON,
} from './FindAccountQueryResponse';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';

/**
 * 
 * @export
 * @interface ListAccountQueryResponse
 */
export interface ListAccountQueryResponse {
    /**
     * 
     * @type {ListMeta}
     * @memberof ListAccountQueryResponse
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<FindAccountQueryResponse>}
     * @memberof ListAccountQueryResponse
     */
    data: Array<FindAccountQueryResponse>;
}

/**
 * Check if a given object implements the ListAccountQueryResponse interface.
 */
export function instanceOfListAccountQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ListAccountQueryResponseFromJSON(json: any): ListAccountQueryResponse {
    return ListAccountQueryResponseFromJSONTyped(json, false);
}

export function ListAccountQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAccountQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'data': ((json['data'] as Array<any>).map(FindAccountQueryResponseFromJSON)),
    };
}

export function ListAccountQueryResponseToJSON(value?: ListAccountQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'data': ((value.data as Array<any>).map(FindAccountQueryResponseToJSON)),
    };
}

